import React, { useState, useContext } from 'react';
import Avatar from '@mui/material/Avatar';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useMsal } from '@azure/msal-react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import gotToIcon from './../../../Assets/Icons/GoToIcon.png';
import reviewIcon from './../../../Assets/Icons/reviewIcon.png';
import { ActiveButtonContext } from '../../../Contexts/ActiveButtonContext';
import { AccessContext } from '../../../Contexts/AccessContext';
import ContributorFormPopup from '../../ContributePageComponent.js/ContributorFormPopup';
import FeedBackComponent from '../../FeedBack/FeedBackComponent';
import PopupSetUp from '../../FeedBack/PopUpSetUp';
import { toast } from 'react-toastify';
import { useApiAccess } from '../../../Contexts/ApiAccessProvider';

import ContributionGuidePopup from '../../ApiHub/ContributionGuidePopup';
import envConfig from '../../../config/config';

const UpperPanel = () => {
  const { accounts, instance } = useMsal();
  const navigate = useNavigate();
  const { activeButton } = useContext(ActiveButtonContext);
  const { canContribute, inProgress, accessLoading } = useContext(AccessContext);
  const { apiAccessRole, apiAccessLoading } = useApiAccess();

  const [anchorEl, setAnchorEl] = useState(null);
  const [contributor, setContributor] = useState(false);
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);
  const [isGuideOpen, setIsGuideOpen] = useState(false);  // popup state for guide

  const name = accounts[0]?.name;

  const stringToColor = (string) => {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    return color;
  };

  const stringAvatar = (name) => ({
    sx: { bgcolor: stringToColor(name) },
    children: `${name?.split(' ')[0][0]}${name?.split(' ')[1][0]}`,
  });

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleLogout = () => {
    instance.logout().then(() => {
      localStorage.clear();
      sessionStorage.clear();
      navigate('/');
    }).catch(console.error);
  };

  const handleBeContributor = () => setContributor(true);
  const handleContributor = () => navigate('/UIRepo/Contributor');
  const handleApiContributor = () => navigate('/APIRepo/Contributor');

  // Instead of directly sending request here, open the guide popup first
  const handleBeContributorApi = () => {
    setIsGuideOpen(true);
  };

  // Called when user clicks "Proceed" in guide popup
  const handleProceedContributionRequest = async () => {
    setIsGuideOpen(false);

    try {
      const email = accounts[0]?.username.toLowerCase();
      if (!email) return;
      await axios.post(
        `${envConfig.REACT_APP_APIREPO_WRITE}/apirepo/v0.1/sendmail/request`,
        {
          email,
          action: "user_request"
        }
      );
      // 1. Attempt to update user role status first
      await axios.patch(
        `${envConfig.REACT_APP_APIREPO_LOGIN}/apirepo/v0.1/updateUser`,
        {
          email,
          roleChange: 'publisher',
          roleChangeStatus: 'pending',
        }
      );
      toast.success('Request sent successfully');
    } catch (error) {
      console.error('Error updating user role or sending contributor request:', error);
      toast.error('Failed to send request');
    } finally {

    }
  };

  const toggleFeedbackPopup = () => setIsFeedbackOpen(!isFeedbackOpen);

  const playgroundRedirect = () => {
    if (activeButton === 'UI Repo') {
      window.open('https://playground.devsuiteltts.com/#/angular/DataGrid', '_blank');
    } else if (activeButton === 'API Repo') {
      window.open('https://playground.devsuiteltts.com/#/react/Data_Management', '_blank');
    }
    else if (activeButton === 'Help') {
      window.open('https://playground.devsuiteltts.com/#/angular/DataGrid', '_blank');
    }
  };

  return (
    <nav className="w-full">
      <div className="bg-[#002746] justify-between py-2 pb-14 items-center flex flex-col">
        <div className="flex px-6 justify-between w-full py-2 items-center">
          <div>
            <h3 className="text-white text-lg">Dashboard</h3>
            <p className="text-[#0077CF] text-sm font-bold">{activeButton}</p>
          </div>
          <div className="flex gap-4 items-center">
            <p className="text-white py-1">Hi {name}</p>
            <div className="flex items-center">
              <Avatar {...stringAvatar(name)} sx={{ width: 35, height: 35 }} onClick={handleMenuOpen} />
              <ArrowDropDownIcon sx={{ color: 'white', cursor: 'pointer' }} onClick={handleMenuOpen} />
              <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem onClick={handleMenuClose}>
                  <button onClick={handleLogout} className="w-full text-black py-2 px-4">Logout</button>
                </MenuItem>
              </Menu>
            </div>
          </div>
        </div>

        <div className="bg-[#002746] w-full flex justify-end gap-2 pr-6">
          <div className="flex flex-wrap lg:flex-row gap-2 text-center">
            <div className="w-52">
              {activeButton === 'UI Repo' && (
                accessLoading ? (
                  <div className="w-full h-[42px] bg-[#f2f2f2] animate-pulse rounded" />
                ) : canContribute && !inProgress ? (
                  <button className="w-full font-bold py-2 px-4 rounded bg-[#0075cf] text-white" onClick={handleContributor}>
                    Contribute
                  </button>
                ) : inProgress ? (
                  <button className="w-full font-bold py-2 px-4 rounded bg-gray-400 text-white cursor-not-allowed" disabled>
                    Approval Pending
                  </button>
                ) : (
                  <button className="w-full font-bold py-2 px-4 rounded bg-[#0075cf] text-[#ffffff]" onClick={handleBeContributor}>
                    Be a Contributor
                  </button>
                )
              )}

              {activeButton === 'API Repo' && (
                apiAccessLoading ? (
                  <div className="w-full h-[42px] bg-[#f2f2f2] animate-pulse rounded" />
                ) : apiAccessRole === 'publisher' ? (
                  <button className="w-full font-bold py-2 px-4 rounded bg-[#0075cf] text-white" onClick={handleApiContributor}>
                    Contribute
                  </button>
                ) : apiAccessRole === 'pending' ? (
                  <button className="w-full font-bold py-2 px-4 rounded bg-gray-400 text-white cursor-not-allowed" disabled>
                    Approval Pending
                  </button>
                ) : (
                  <button className="w-full font-bold py-2 px-4 rounded bg-[#0075cf] text-[#ffffff]" onClick={handleBeContributorApi}>
                    Be a Contributor
                  </button>
                )
              )}
            </div>

            <div className="w-52">
              <button className="w-full bg-white text-black font-bold py-2 px-4 rounded flex items-center justify-center" onClick={playgroundRedirect}>
                <img src={gotToIcon} alt="goto" className="mr-2" />
                Go to Playground
              </button>
            </div>

            <div className="w-52">
              <button className="w-full text-white bg-transparent border border-[#C5C5C5] font-bold py-2 px-4 rounded flex items-center justify-center" onClick={toggleFeedbackPopup}>
                <img src={reviewIcon} alt="feedback" className="mr-2" />
                Send Feedback
              </button>
            </div>
          </div>
        </div>
      </div>

      {contributor && activeButton === 'UI Repo' && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="rounded-md shadow-lg w-screen h-screen relative">
            <ContributorFormPopup contributor={contributor} setContributor={setContributor} />
          </div>
        </div>
      )}

      {isFeedbackOpen && (
        <PopupSetUp onClose={toggleFeedbackPopup}>
          <FeedBackComponent />
        </PopupSetUp>
      )}

      {/* Contribution guide popup for API Repo */}
      <ContributionGuidePopup
        isOpen={isGuideOpen}
        onClose={() => setIsGuideOpen(false)}
        onProceed={handleProceedContributionRequest}
      />
    </nav>
  );
};

export default UpperPanel;
